/* Maison Flash — scripts for extra sections */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------------- Slideshow ---------------- */
  function initSlideshow(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const slides = $$('.slideshow__slide', root);
    const dots = $$('[data-slide-to]', root);
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;

    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => {
        s.classList.toggle('is-active', n === index);
        s.setAttribute('aria-hidden', n === index ? 'false' : 'true');
      });
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    }
    function start() {
      stop();
      if (root.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(() => go(index + 1), (parseInt(root.dataset.speed, 10) || 5) * 1000);
    }
    function stop() { if (timer) clearInterval(timer); }

    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-slide-next]')) { go(index + 1); start(); }
      else if (e.target.closest('[data-slide-prev]')) { go(index - 1); start(); }
      else {
        const d = e.target.closest('[data-slide-to]');
        if (d) { go(parseInt(d.dataset.slideTo, 10)); start(); }
      }
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    let x0 = null;
    root.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });

    // Theme editor: show the selected block
    root.addEventListener('shopify:block:select', (e) => {
      const i = slides.indexOf(e.target);
      if (i > -1) { stop(); go(i); }
    });
    start();
  }

  /* ---------------- Copy promo code ---------------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-copy]');
    if (!b) return;
    const label = $('[data-copy-label]', b);
    try {
      await navigator.clipboard.writeText(b.dataset.copy);
      if (label) {
        const txt = label.textContent;
        label.textContent = b.dataset.copiedLabel || 'Copié !';
        setTimeout(() => { label.textContent = txt; }, 1800);
      }
    } catch (_) { /* clipboard unavailable */ }
  });

  /* ---------------- Video with cover ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-video-play]');
    if (!b) return;
    const tpl = $('template', b.closest('[data-video]'));
    if (!tpl) return;
    b.replaceWith(tpl.content.cloneNode(true));
  });

  /* ---------------- Newsletter popup ---------------- */
  const POP_KEY = 'mf_popup_closed_at';
  function initPopup(popup) {
    if (!popup || popup.dataset.ready) return;
    popup.dataset.ready = '1';
    if (popup.hasAttribute('data-design-mode')) return; // opened on section select in the editor
    const days = parseInt(popup.dataset.days, 10) || 7;
    let closedAt = 0;
    try { closedAt = parseInt(localStorage.getItem(POP_KEY), 10) || 0; } catch (_) {}
    if (closedAt && Date.now() - closedAt < days * 86400000) return;
    setTimeout(() => {
      if (!document.querySelector('.modal.is-open, .drawer.is-open')) popup.classList.add('is-open');
    }, (parseInt(popup.dataset.delay, 10) || 5) * 1000);
  }
  function rememberPopupClosed() {
    try { localStorage.setItem(POP_KEY, String(Date.now())); } catch (_) {}
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-popup-close]') || (e.target.matches && e.target.matches('[data-popup]'))) rememberPopupClosed();
  });
  document.addEventListener('submit', (e) => {
    if (e.target.closest('[data-popup]')) rememberPopupClosed();
  });

  /* ---------------- Init + theme editor support ---------------- */
  function init(ctx) {
    $$('[data-slideshow]', ctx).forEach(initSlideshow);
    $$('[data-popup]', ctx).forEach(initPopup);
  }
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const p = $('[data-popup]', e.target);
    if (p) p.classList.add('is-open');
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const p = $('[data-popup]', e.target);
    if (p) p.classList.remove('is-open');
  });
})();
